<template>
  <a
    :class="[
      ns.b(),
      ns.m(type),
      ns.is('disabled', disabled),
      ns.is('underline', underline && !disabled),
    ]"
    :href="disabled || !href ? undefined : href"
    data-test-name="link"
    data-test-variant=""
    data-test-state=""
    @click="handleClick"
  >
    <b-icon v-if="icon"><component :is="icon" /></b-icon>
    <span v-if="$slots.default" :class="ns.e('inner')">
      <slot />
    </span>

    <slot v-if="$slots.icon" name="icon" />
  </a>
</template>

<script lang="ts" setup>
import { BIcon } from '@bigin/components/icon'
import { useNamespace } from '@bigin/hooks'
import { linkEmits, linkProps } from './link'

defineOptions({
  name: 'BLink',
})
const props = defineProps(linkProps)
const emit = defineEmits(linkEmits)

const ns = useNamespace('link')

function handleClick(event: MouseEvent) {
  if (!props.disabled) emit('click', event)
}
</script>
